export default [
	{
		"text": "AD10反馈管理", "icon": "el-icon-s-home",
		"child": [
			{ "text": "反馈列表", "icon": "el-icon-tickets", "path": "/Advancer" },
			{ "text": "OBD日志列表", "icon": "el-icon-tickets", "path": "/AdvancerOBDList" },
			// { "text": "模板列表", "icon": "el-icon-tickets", "path": "/ad10feedback" },
		]
	},
]